import { render, staticRenderFns } from "./VerLegajo.vue?vue&type=template&id=467e9da4&"
import script from "./VerLegajo.vue?vue&type=script&lang=js&"
export * from "./VerLegajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports